<div class="login-layout">
  <app-promo-ticker class="login-layout__ticker"></app-promo-ticker>
  <main class="login-layout__main">
    <router-outlet></router-outlet>
  </main>
  <app-footer id="footer" class="col-sm-12 main-footer"></app-footer>
</div>
